<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 11</h1>
          <div class="text-left">
          <p>London</p>
          <a href="/uk/11London.jpeg"><img alt="London" class="uitk-image-media" src="11London.jpeg" style="width: 17%; height: auto;"></a>
          <a href="/uk/11London2.jpeg"><img alt="London" class="uitk-image-media" src="11London2.jpeg" style="width: 17%; height: auto;"></a>
          <a href="/uk/11London3.jpeg"><img alt="London" class="uitk-image-media" src="11London3.jpeg" style="width: 17%; height: auto;"></a>
          <a href="/uk/11London4.jpeg"><img alt="London" class="uitk-image-media" src="11London4.jpeg" style="width: 17%; height: auto;"></a>
          <p>Frank with his $9 coffee</p>
          <a href="/uk/11Frank.jpeg"><img alt="Frank with his coffee" class="uitk-image-media" src="11Frank.jpeg" style="width: 17%; height: auto;"></a>
          <p>Portait Museum</p>
          <a href="/uk/11Portait.jpeg"><img alt="portrait museum" class="uitk-image-media" src="11Portait.jpeg" style="width: 17%; height: auto;"></a>    
          <a href="/uk/11Portrait2.jpeg"><img alt="portrait museum" class="uitk-image-media" src="11Portrait2.jpeg" style="width: 17%; height: auto;"></a>  
          <a href="/uk/11Portrait3.jpeg"><img alt="portrait museum" class="uitk-image-media" src="11Portrait3.jpeg" style="width: 17%; height: auto;"></a>  
          <a href="/uk/11Portrait4.jpeg"><img alt="portrait museum" class="uitk-image-media" src="11Portrait4.jpeg" style="width: 17%; height: auto;"></a>    
          <p>Art Gallery</p>
          <a href="/uk/11Gallery.jpeg"><img alt="Art Gallery" class="uitk-image-media" src="11Gallery.jpeg" style="width: 17%; height: auto;"></a>    
          <a href="/uk/11Gallery2.jpeg"><img alt="Art Gallery" class="uitk-image-media" src="11Gallery2.jpeg" style="width: 17%; height: auto;"></a>    
          <a href="/uk/11Gallery3.jpeg"><img alt="Art Gallery" class="uitk-image-media" src="11Gallery3.jpeg" style="width: 17%; height: auto;"></a>    
          <a href="/uk/11Gallery4.jpeg"><img alt="Art Gallery" class="uitk-image-media" src="11Gallery4.jpeg" style="width: 17%; height: auto;"></a>    
          <a href="/uk/11Gallery5.jpeg"><img alt="Art Gallery" class="uitk-image-media" src="11Gallery5.jpeg" style="width: 17%; height: auto;"></a>    
          <p>Royal Albert Hall - the only place to see a midget floating with balloons</p>
          <p>We got upgraded to a box on the level below for free</p>
          <a href="/uk/11Albert.jpeg"><img alt="Royal Albert Hall" class="uitk-image-media" src="11Albert.jpeg" style="width: 17%; height: auto;"></a>          
          <a href="/uk/11Albert21.jpeg"><img alt="Royal Albert Hall" class="uitk-image-media" src="11Albert21.jpeg" style="width: 17%; height: auto;"></a>          
          </div>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
      ////
    }
  }
  </script>